import { Link } from "react-router-dom";
import { BookOpen, Compass, ArrowRight } from "lucide-react";
import { OVERVIEW_SHORTCUTS } from "./documentationOverviewContent";

export function OverviewHero() {
  return (
    <section
      aria-labelledby="doc-hero-title"
      className="relative overflow-hidden rounded-2xl border border-primary/10 bg-gradient-to-br from-primary/5 via-white to-blue-50 p-8 md:p-10 animate-fade-in-up"
    >
      <div
        className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-primary/10 blur-3xl"
        aria-hidden
      />
      <div
        className="absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-blue-200/30 blur-3xl"
        aria-hidden
      />

      <div className="relative">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-primary ring-1 ring-primary/15 backdrop-blur">
          <BookOpen className="h-3.5 w-3.5" />
          Help center
        </span>

        <h1
          id="doc-hero-title"
          className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900"
        >
          Welcome to PhiloLMS
        </h1>
        <p className="mt-3 max-w-2xl text-base md:text-lg leading-relaxed text-slate-600">
          Everything you need to run your library — from the front desk to the back office. Pick
          your role, jump to a module, or follow a quick how-to below.
        </p>

        <div className="mt-6 flex flex-wrap items-center gap-3">
          <a
            href="#modules"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition-all duration-200 ease-out hover:bg-primary-600 hover:shadow-md active:scale-[0.98]"
          >
            <Compass className="h-4 w-4" />
            Browse modules
          </a>
          <a
            href="#getting-started"
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition-all duration-200 ease-out hover:border-primary/40 hover:text-primary active:scale-[0.98]"
          >
            I'm new here
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <ul className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          {OVERVIEW_SHORTCUTS.map(({ icon: Icon, label, to }) => (
            <li key={to}>
              <Link
                to={to}
                className="group flex items-center gap-2 rounded-lg border border-slate-200/80 bg-white/70 px-3 py-2 text-sm font-medium text-slate-700 backdrop-blur transition-all duration-200 ease-out hover:border-primary/40 hover:bg-white hover:text-primary hover:shadow-sm"
              >
                <Icon className="h-4 w-4 text-slate-500 transition-colors group-hover:text-primary" />
                <span className="truncate">{label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
